import { v4 as uuidv4 } from 'uuid';
import { normalizeHexColor } from './richText.js';
import { normalizeStoredImageItem, revokeLocalImageUrl } from './localImage.js';
import { LOCAL_ASSET } from './localAssets.js';
import { getQiniuSignedUrl } from './qiniuMedia.js';

export const HEADER_INFO_CARD_COMPONENT_TYPE = 'header-info-card';
export const HEADER_INFO_CARD_MODULE_TYPE = 'infoCard';

export const HEADER_INFO_CARD_DEFAULT_IMAGE_SIZE = 160;
export const HEADER_INFO_CARD_COMPACT_IMAGE_SIZE = 110;
export const HEADER_INFO_CARD_DEFAULT_BORDER_WIDTH = 4;
export const HEADER_INFO_CARD_COMPACT_BORDER_WIDTH = 4;
export const HEADER_INFO_CARD_DEFAULT_IMAGE_RADIUS = 8;
export const HEADER_INFO_CARD_COMPACT_IMAGE_RADIUS = 8;

const DEFAULT_TITLE = '自媒体运营表格工具';
const DEFAULT_SUBTITLE = '选题库·发布排期·数据复盘表.xlsx';
const DEFAULT_BORDER_COLOR = '#5eb3ff';
const DEFAULT_TITLE_COLOR = '#000000';
const DEFAULT_SUBTITLE_COLOR = '#333333';

function createDefaultCoverImage() {
	return {
		id: `header-info-card-cover-${uuidv4()}`,
		filename: 'cover.jpg',
		previewUrl: LOCAL_ASSET.headerInfoCard,
		url: '',
		local: false,
	};
}

export function getHeaderInfoCardImageUrl(image) {
	if (!image) return '';
	return getQiniuSignedUrl(image.previewUrl || image.url || '');
}

export function getHeaderInfoCardDefaults() {
	return normalizeHeaderInfoCardData({});
}

export function isHeaderInfoCardComponent(type) {
	return type === HEADER_INFO_CARD_COMPONENT_TYPE;
}

function normalizeCoverImage(image) {
	if (!image?.previewUrl && !image?.url) {
		return createDefaultCoverImage();
	}
	return normalizeStoredImageItem(image, createDefaultCoverImage());
}

export function normalizeHeaderInfoCardData(data = {}) {
	return {
		title: typeof data.title === 'string' ? data.title : DEFAULT_TITLE,
		subtitle: typeof data.subtitle === 'string' ? data.subtitle : DEFAULT_SUBTITLE,
		borderColor: normalizeHexColor(data.borderColor || DEFAULT_BORDER_COLOR),
		titleColor: normalizeHexColor(data.titleColor || DEFAULT_TITLE_COLOR),
		subtitleColor: normalizeHexColor(data.subtitleColor || DEFAULT_SUBTITLE_COLOR),
		imageSize: Math.max(
			64,
			Number(data.imageSize) || HEADER_INFO_CARD_DEFAULT_IMAGE_SIZE,
		),
		borderWidth: Math.max(
			1,
			Number(data.borderWidth) || HEADER_INFO_CARD_DEFAULT_BORDER_WIDTH,
		),
		imageRadius: Math.max(
			0,
			Number(data.imageRadius) || HEADER_INFO_CARD_DEFAULT_IMAGE_RADIUS,
		),
		image: normalizeCoverImage(data.image),
		jumpLink: data?.jumpLink?.type ? { ...data.jumpLink } : null,
	};
}

export function revokeHeaderInfoCardImages(data) {
	revokeLocalImageUrl(data?.image?.previewUrl);
}
